<template>
  <div v-if="allHints.length" class="alert alert-warning mt-3 mb-0">
    <ul class="mb-0 ps-3">
      <li v-for="(hint, index) in allHints" :key="`${index}-${hint}`">
        {{ hint }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "InvoiceHints",
  props: {
    invoice: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    allHints() {
      const invoiceHints = Array.isArray(this.invoice?.hints) ? this.invoice.hints : [];
      const positionHints = (this.invoice?.positions || [])
        .flatMap((position) => (Array.isArray(position?.hints) ? position.hints : []));

      return [...new Set([...invoiceHints, ...positionHints])];
    },
  },
};
</script>
